/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { object } from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import SkeletonStyles from './SkeletonStyles';

const styles = () => ({
    // Import Skeleton layout
    ...SkeletonStyles,

    // Page Elements
    root: {},
    pageWrapper: {
        display: 'grid',
        gridTemplateColumns: '100px auto auto',
        gridGap: '10px',
        margin: '0 auto',
        width: '100%',
        maxWidth: '1376px',
    },
    altImage: {
        marginBottom: '10px',
        width: '100%',
        height: '113px',
    },
    heroImage: {
        marginBottom: '10px',
        width: '100%',
        height: '667px',
    },
    smartGift: {
        width: '100%',
        height: '113px',
    },
    productInfo: {
        '&--blockHeader': {
            margin: '10px 0',
            width: '100%',
            height: '32px',
        },
        '&--blockBody': {
            width: '100%',
            height: '202px',
        },
        '&--passport': {
            margin: '20px 0',
            width: '100%',
            height: '77px',
        },
    },
});

const PLASkeleton = ({ classes }) => (
    <div className={classes.root}>
        <div className={classes.pageWrapper}>
            <div>
                <div className={`${classes.altImage} ${classes.block}`} />
                <div className={`${classes.altImage} ${classes.block}`} />
            </div>
            <div>
                <div className={`${classes.heroImage} ${classes.block}`} />
                <div className={`${classes.smartGift} ${classes.block}`} />
            </div>
            <div>
                <div className={`${classes.textLG}`} />
                <div className={`${classes.productInfo}--blockHeader ${classes.block}`} />
                <div className={`${classes.productInfo}--blockBody ${classes.block}`} />
                <div className={`${classes.productInfo}--passport ${classes.block}`} />
                <div className={`${classes.productInfo}--blockHeader ${classes.block}`} />
                <div className={`${classes.productInfo}--blockBody ${classes.block}`} />
            </div>
        </div>
    </div>
);

PLASkeleton.propTypes = {
    classes: object.isRequired,
};

export default withStyles(styles)(PLASkeleton);
